/** @jsxImportSource ../i18n */
import React from 'react';

// Mascots shipped under public/mascotte. Keep ids in sync with the backend
// allow-list (backend/internal/services/mascots.go).
export const MASCOTS = [
  { id: 'gladys', name: 'Gladys', description: 'Conseillère classique', img: '/mascotte/cards/gladys.webp' },
  { id: 'gladys-open', name: 'Gladys Open', description: 'Déboutonne son chemisier au survol', img: '/mascotte/cards/gladys-open.webp' },
  { id: 'gladys-manga', name: 'Gladys Manga', description: 'Gladys manga animée (Spine) : 5 expressions, physique du buste et des cheveux', img: '/mascotte/cards/gladys-manga.webp' },
  { id: 'gladys-undress', name: 'Gladys Undress', description: 'Retire son chemisier au survol', img: '/mascotte/cards/gladys-undress.webp' },
  { id: 'v5', name: 'V5', description: 'Style cartoon d’après photo : manteau et sweat à capuche', img: '/mascotte/cards/v5.webp' },
  { id: 'v6', name: 'V6', description: 'V5 avec le sweat ouvert jusqu’à la taille', img: '/mascotte/cards/v6.webp' },
  { id: 'v7', name: 'V7', description: 'Cliquez : elle ouvre et referme elle-même son sweat', img: '/mascotte/cards/v7.webp' },
];

export const mascotById = (id) => MASCOTS.find((m) => m.id === id);

const SIZES = { sm: 'w-7 h-7 text-[10px]', md: 'w-10 h-10 text-xs', lg: 'w-14 h-14 text-sm', portrait: 'w-28 h-36 text-2xl', seat: 'w-28 h-36 lg:w-24 lg:h-32 text-2xl' };

const initials = (name) => (name || '?').trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase();

// Avatar of an expert (round, or a large 'portrait' card): its mascot, or its initials when it has none.
export const MascotAvatar = ({ variant, name, size = 'md' }) => {
  const mascot = mascotById(variant);
  const shape = size === 'portrait' || size === 'seat' ? 'rounded-2xl' : 'rounded-full';
  const cls = `${SIZES[size]} ${shape} flex-shrink-0 overflow-hidden border border-line-strong bg-surface-2`;
  return mascot ? (
    <img src={mascot.img} alt={`${name} (${mascot.name})`} title={mascot.name} className={`${cls} object-cover object-top`} data-testid="mascot-avatar" />
  ) : (
    <span className={`${cls} inline-flex items-center justify-center font-display font-medium text-gold-300`} aria-hidden="true" data-testid="mascot-initials">{initials(name)}</span>
  );
};
